import K from '../constants/AboutConstants';
import axios from 'axios';

export const getBiography = () => {
    return dispatch => {
        const endpoint = `${process.env.REACT_APP_API_URL}/api/about/findOne`;
        axios
            .get(endpoint)
            .then(function(response) {
                dispatch({
                    type: K.GET_BIOGRAPHY,
                    payload: response.data
                });
            })
            .catch(function(error) {
                console.log(error);
            });
    };
};



// WEBPACK FOOTER //
// ./src/actions/AboutActions.js